import React from "react"

import styles from "./CoreList.module.scss"

const CoreList = ({ html, type, variant }) => {
  const camelCase = require("camelcase")
  return (
    <section
      className={`${styles.list} ${styles[camelCase("" + type)]} ${
        styles[camelCase("" + variant)]
      }`}
      dangerouslySetInnerHTML={{ __html: html }}
    ></section>
  )
}

CoreList.defaultProps = {
  type: "unordered",
  variant: "default",
}

export default CoreList
